import React from "react";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";

function DialogConstantForForecastMethod({ open, onCancel, onDone }) {
  const [constant, setConstant] = React.useState("");
  const handleChange = (event) => {
    setConstant(event.target.value);
  };

  return (
    <Dialog open={open} onClose={onCancel} aria-labelledby="form-dialog-title">
      <DialogTitle id="form-dialog-title">Export Project</DialogTitle>
      <DialogContent>
        <DialogContentText>
          Please enter the constant for the forecast value:
        </DialogContentText>
        <TextField
          autoComplete="off"
          autoFocus
          margin="dense"
          id="period"
          label="Constant for the Forecast Value"
          type="text"
          value={constant}
          onChange={handleChange}
          fullWidth
        />
      </DialogContent>
      <DialogActions>
        <Button
          onClick={() => {
            onCancel();
            setConstant("");
          }}
          color="secondary"
        >
          Cancel
        </Button>
        <Button
          onClick={() => {
            onDone(constant);
            setConstant("");
          }}
          color="primary"
        >
          Done
        </Button>
      </DialogActions>
    </Dialog>
  );
}
export default DialogConstantForForecastMethod;
